import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Breadcrumbs from '../components/Breadcrumbs';
import { ReactComponent as TickIcon } from '../assets/images/green-tick.svg';
import { ReactComponent as CrownIcon } from '../assets/images/yellow-crown.svg';

function VocabularyDetail() {
  const API_URL = process.env.REACT_APP_API_URL;
  const { interfaceLang, courseLang, vocabularyCategory } = useParams();  // Récupère l'ID du cours à partir de l'URL
  const [sessions, setSessions] = useState({});
  const [loadingSessions, setLoadingSessions] = useState(true);
  
  // Type d'exercices disponibles
  const listAvailableExercise = [
    { id:'matches', name: 'matches'},
    { id:'qcm', name: 'qcm'},
    { id:'traduction', name: 'traduction'},
    { id:'traduction-letter', name: 'traduction-letter'},
    { id:'mot-melee', name: 'mot-melee'},
    ]

  useEffect(() => {
    const token = localStorage.getItem('access_token');

    // Pour chaque type d'exercice, on récupère la session correspondante
    const fetchSessions = async () => {
        const newSessions = {};
        for (let exercise of listAvailableExercise) {
          try {
            const response = await axios.get(
              `${API_URL}/cours/api/vocabulaire/${vocabularyCategory}/showsession/${exercise.id}/`,
              {
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              }
            );
            newSessions[exercise.id] = response.data;
          } catch (error) {
            console.error("Erreur lors de la récupération de la session pour", exercise.id, error);
          }
        }
        setSessions(newSessions);
        setLoadingSessions(false);
      };
  
      fetchSessions();
    }, [API_URL, vocabularyCategory]);

  // Exemple de structure pour le fil d'Ariane 
  const breadcrumbsLinks = [
    { label: 'Accueil', path: `/${interfaceLang}` },
    { label: 'Langues & Vocabulaire', path:  `/${interfaceLang}/courses/${courseLang}` },
    { label: vocabularyCategory, path: `/${interfaceLang}/courses/${courseLang}/vocabulary/${vocabularyCategory}` }
  ];

  return (
    <div className="course-detail max-w-4xl mx-auto mt-8 px-4">
      <Breadcrumbs links={breadcrumbsLinks} />
  
      <div>
        <h1 className="text-3xl font-bold text-blue-600 mb-2">{vocabularyCategory}</h1>
        <p className="text-lg text-gray-600 mb-8">{vocabularyCategory + '_description'}</p>
  
        <h2 className="text-2xl font-semibold text-blue-500 mb-6">Exercices disponibles</h2>
  
        {loadingSessions ? (
          <p className="text-gray-500">Chargement des sessions...</p>
        ) : (
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {listAvailableExercise.map(exercise => {
              const session = sessions[exercise.id] || {};

              const {
                progression = 0,
                total_word = 0,
                word_validated = 0,
                word_corrected = 0,
                word_failed = 0,
                word_pending = 0,
              } = session;
              const word_complete = session.word_validated + session.word_corrected
              const isComplete = word_complete === session.total_word;
              const isPerfect = isComplete && session.word_validated === session.total_word;
              
              console.log("Le niveau est :", isComplete)
              const bgClass = isComplete 
                ? isPerfect 
                  ? "bg-yellow-100 m-1" // couleur dorée pâle pour l'excellence
                  : "bg-green-100 m-1"  // vert clair pour l'exercice terminé
                : "bg-white";

              const titleClass = isComplete 
                ? isPerfect 
                  ? "text-yellow-600"
                  : "text-green-600"
                : "text-gray-800";

              // Classe pour l'animation de bordure (définie dans un fichier CSS réutilisable)
              const animatedBorderClass = isComplete ? "animated-border" : "";
              
              return (

                <li key={exercise.id} className={"relative rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden"}>
                     {/* Si l'exercice est terminé, on affiche les div pour l'effet de bordure animée */}
                      {isComplete && (
                        <>
                          <div className={`animated-border-box-glow ${
                            isPerfect 
                            ? 'animated-border-glow-yellow' 
                            : 'animated-border-glow-green'}`} />
                          <div className="animated-border-box" />
                        </>
                      )} 
                    
                    {/* Contenu de la carte avec fond coloré et positionné au-dessus des effets */}
                    <div className={`${bgClass} relative z-10 rounded-2xl p-5`}>
                      <Link
                        to={`/${interfaceLang}/courses/${courseLang}/vocabulary/${vocabularyCategory}/exercise/${exercise.id}?sessionId=${session.id || ''}`}
                        className="space-y-4"
                      >
                        <h3 className={`text-xl font-semibold ${titleClass}`}>Exercice {exercise.name}</h3>
      
                        {/* Barre de progression */}
                        <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                          <div className="flex h-full w-full">
                            <div className="bg-green-500" style={{ width: `${(word_validated / total_word) * 100 || 0}%` }} />
                            <div className="bg-orange-400" style={{ width: `${(word_corrected / total_word) * 100 || 0}%` }} />
                            <div className="bg-red-500" style={{ width: `${(word_failed / total_word) * 100 || 0}%` }} />
                            <div className="bg-gray-400" style={{ width: `${(word_pending / total_word) * 100 || 0}%` }} />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 place-items-center">
                        {/* Statistiques */}
                          <div className="text-sm text-gray-600">
                            <p className="mb-1">Progression : {Math.trunc((word_validated+word_corrected)*100/total_word )}%</p>
                            <div className="space-y-1">
                              <p>Mots totaux : {total_word}</p>
                              <p className="text-green-600">Validés : {word_validated}</p>
                              <p className="text-orange-500">Corrigés : {word_corrected}</p>
                              <p className="text-red-500">Erreurs : {word_failed}</p>
                            </div>
                          </div>

                          {/* Icone en fonction du statut */}
                          {isComplete && (
                            isPerfect 
                              ? <div className="w-12 h-12 couronne"><CrownIcon /></div>
                              : <div className="w-12 h-12"><TickIcon /></div>
                          )}
                        </div>
                      </Link>
                    </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default VocabularyDetail;
